<template>
  <div class="container">
    <div class="content">
      <div id="box2" class="p2">使用</div>
      <div class="p3" style="width: 140%;">我们将使用 Remix IDE 编写您的 NFT 合约。在此示例中，我们将使用 OpenZeppenlin 的 ERC721URIStorage。 </div>
      <div class="p3">打开 <a class="click" href="https://remix.ethereum.org/" target="_blank">Remix IDE</a>，创建一个新的solidity文件，命名NFTExample.sol并复制合约代码。</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 0px 0">// SPDX-License-Identifier: UNLICENSED</div>
          <div style="padding:0px 0 0px 0">pragma solidity >=0.4.22 <0.9.0;</div>
          <div style="padding:0px 0 0px 0">import "@openzeppelin/contracts/token/ERC721/extensions/ERC721URIStorage.sol";</div>
          <div style="padding:0px 0 15px 0">import "@openzeppelin/contracts/utils/Counters.sol";</div>
          <div style="padding:5px 0 0px 0">contract FAXNFT is ERC721URIStorage{</div>
          <div style="padding:0px 0 0px 30px">using Counters for Counters.Counter;</div>
          <div style="padding:0px 0 0px 30px">Counters.Counter private _tokenIds;</div>
          <div style="padding:0px 0 20px 30px">event NewNFTMinted(address sender, uint256 tokenId, string tokenURI);</div>
          <div style="padding:0px 0 20px 30px"> constructor() ERC721 ("NFT Examples on FAX", "FAX-NFT") {}</div>
          <div style="padding:0px 0 0px 30px">function mintItem(string memory tokenURI) public{</div>
          <div style="padding:0px 0 0px 60px"> _tokenIds.increment();</div>
          <div style="padding:0px 0 0px 60px"> uint256 newItemId = _tokenIds.current();</div>
          <div style="padding:0px 0 0px 60px">_mint(msg.sender, newItemId);</div>
          <div style="padding:0px 0 0px 60px">_setTokenURI(newItemId, tokenURI);</div>
          <div style="padding:0px 0 0px 60px">emit NewNFTMinted(msg.sender, newItemId, tokenURI);</div>
          <div style="padding:0px 0 0px 30px">}</div>
          <div style="padding:0px 0 0px 0">}</div>
        </div>
      </div>

      <div class="p3">如果一切正常，Remix 将自动编译您的智能合约。</div>



      <div id="box2" class="p2">部署您的 NFT</div>
      <div class="p3">在部署 NFT 智能合约之前，请确保您将网络切换到 MetaMask 上的 FAX MainNet。</div>
      <div class="p3">在 RemixIDE 上，转到Deployment页面并确保选择Injected Provider - MetaMask环境。现在，您可以单击Deply按钮并在MetaMask 上确认交易。</div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'testnetUpdate',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
span
  padding: 2px 5px
  color: red
  border: 1px solid #ccc
  font-size: 12px
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
        word-break: break-all
        .click
          color: rgba(237, 199, 83)
          font-weight: 500
          font-size: 16px
          border: 0
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
        word-break: break-all
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>